import React, { useState, useCallback, lazy, Suspense } from 'react';
import { Modal } from 'react-bootstrap';
import './index.css';
import { BorrowerLeadGenerationTool } from 'borrower-lead-generation-tool';

// const LazyBorrowerLeadGenerationTool = lazy(() =>
//   import('borrower-lead-generation-tool').then(module => ({
//     default: module.default || module.BorrowerLeadGenerationTool,
//   }))
// );

const LeadFormModal = ({
  loanOfficerId,
  branchCode,
  leadSrc,
  loanPurpKeyword,
  formHeading,
  showLeadFormModal,
  onHide,
}) => {
  const [node, setNode] = useState(null);
  const formRef = useCallback(node => setNode(node), []);
  
  //navbar stores the query param "rlo"-(refering loan officer) in session storage.
  //if rlo exists in session storage then use rlo if not, use whatever is passed to LeadFormModal Component in the loanOfficerId.
  const queryParamLOId = sessionStorage.getItem('rlo');
  let queryParamBrokerLOId = sessionStorage.getItem('blof');

  if (queryParamLOId) {
    queryParamBrokerLOId = '';
  }

  const sessionStorageLOId = queryParamLOId || (queryParamBrokerLOId || '');
  const sessionStorageLOLeadSource = queryParamLOId
    ? 'SELF'
    : queryParamBrokerLOId
      ? 'SELFGEN'
      : '';
  const isBrokerLoanOfficer = !!queryParamBrokerLOId;
  // MKT-38220
  // check if there is rlo = 'referring loan officer' id code in sessionStorage
  // rlo is set in sessionStorage in navbar code via queryParams to override any passed lo id in the code
  const loID = sessionStorageLOId || loanOfficerId;
  const leadSource = sessionStorageLOLeadSource || leadSrc;
  const showCustomizeLOApplyNowUrl = !!sessionStorageLOId;

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="lead-form-modal"
      show={showLeadFormModal}
      onHide={onHide}
      backdrop="static"
    >
      <Modal.Header className="modal-header" closeButton>
        <Modal.Title>{formHeading}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <Suspense fallback={<div>Loading form...</div>}>
          {showLeadFormModal && (
           <BorrowerLeadGenerationTool
              leadSource={leadSource}
              loanOfficerUid={loID}
              isBrokerLoanOfficer={isBrokerLoanOfficer}
              branch={branchCode}
              loanPurposeKeyword={loanPurpKeyword}
              statesDomain="ny.swmc.com"
              ref={formRef}
              showCustomizeLOApplyNowUrl={showCustomizeLOApplyNowUrl}
              domainNameConsent="swmc.com"
              language="en"
            />
          )}
        </Suspense>
      </Modal.Body>
    </Modal>
  );
};

export default LeadFormModal;
